<mat-card>
  <mat-card-content>
    <canvas id="workedChartCanvas">{{ workedChart }}</canvas>
  </mat-card-content>
</mat-card>
